import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiCallService } from '../../../Services/api-call-service.service';
import { LoaderService } from '../../../Services/loader-service.service';
import { ErrorhandlingService } from '../../../Services/error-handling.service';
import { CommonModule } from '@angular/common';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-featured-cards',
  standalone: true,
  imports: [CommonModule, CarouselModule],
  templateUrl: './featured-cards.component.html',
  styleUrl: './featured-cards.component.scss',
})
export class FeaturedCardsComponent implements OnInit {
  constructor(
    private router: Router,
    private apiCallService: ApiCallService,
    private _loaderService: LoaderService,
    private ErroHandling: ErrorhandlingService
  ) {}

  cardData = [
    {
      title: 'Aviator',
      description: 'Fly high and cash out',
      imageSrc: 'Images/Avaitar.png',
      route: 'Avaitar',
      hot: '',
      gradient: 'from-red-600 via-red-500 to-rose-400'
    },
    {
      title: 'Baccarat',
      description: 'Classic card action',
      imageSrc: 'Images/Baccarat.png',
      route: 'Baccaret',
      hot: '',
      gradient: 'from-emerald-700 via-teal-600 to-cyan-500'
    },
    {
      title: 'Treasure',
      description: 'Unlock the golden vault',
      imageSrc: 'Images/treasure-vault.png',
      route: 'TreasurePick',
      hot: '',
      gradient: 'from-amber-600 via-orange-500 to-yellow-400'
    },
    {
      title: 'Mines',
      description: 'Avoid the bombs to win',
      imageSrc: '/bomb.png',
      route: 'Mines',
      hot: '',
      gradient: 'from-slate-800 via-gray-700 to-zinc-500'
    },
    {
      title: 'Plinko',
      description: 'Watch the balls drop',
      imageSrc: '/plinko.png',
      route: 'Plinko',
      hot: '',
      gradient: 'from-pink-600 via-purple-600 to-indigo-500'
    },
    {
      title: 'Roulette',
      description: 'Spin wheel of fortune',
      imageSrc: '/Rouleet.png',
      route: 'Roulette',
      hot: '',
      gradient: 'from-blue-800 via-blue-600 to-sky-400'
    },
    {
      title: 'Spin',
      description: 'Test your lucky rotation',
      imageSrc: 'Images/spin.png',
      route: 'spinner',
      hot: '',
      gradient: 'from-teal-800 via-emerald-600 to-lime-500'
    },
    {
      title: 'Scratch',
      description: 'Reveal instant rewards',
      imageSrc: 'Images/sactrach.png',
      route: 'SectrechCards',
      hot: '',
      gradient: 'from-violet-800 via-purple-700 to-fuchsia-500'
    }
  ];

  // Owl Carousel Options
  carouselOptions: OwlOptions = {
    loop: true,
    margin: 20,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplayHoverPause: true,
    smartSpeed: 800,
    slideTransition: 'linear',
    autoplaySpeed: 2500,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    freeDrag: false,
    responsive: {
      0: {
        items: 1.1
      },
      480: {
        items: 1.2
      },
      640: {
        items: 1.5
      },
      768: {
        items: 2
      },
      1024: {
        items: 2.4
      },
      1280: {
        items: 2.8
      }
    }
  };

  ngOnInit() {
    this.getGameNews();
  }

  openModule(key: string, event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    const targetRoute = key || '';
    const isValidRoute = this.cardData.some(
      card => card.route.toLowerCase() === targetRoute.toLowerCase()
    );

    if (isValidRoute || targetRoute !== '') {
      this.navigateAndScroll(`/dashboard/${targetRoute}`);
    } else {
      console.warn('[openModule] Unknown module key:', targetRoute);
    }
  }

  private navigateAndScroll(path: string) {
    this.router
      .navigate([path])
      .then((navigated) => {
        if (navigated) {
          this.scrollToTopSmooth();
        }
      })
      .catch(() => {
        this.scrollToTopSmooth();
      });
  }

  private scrollToTopSmooth(): void {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      try {
        window.scrollTo(0, 0);
      } catch {
        // ignore
      }
    }
  }

  // API Call For Hot Games
  gameOffers: any;

  getGameNews() {
    this._loaderService.show();
    const token = localStorage.getItem('token');

    if (token) {
      this.apiCallService
        .GetCallWithToken('TestImonials/GetHotHittingGames')
        .subscribe(
          (response) => {
            if (response && response.responseCode === 200) {
              this.gameOffers = response.data;
              this._loaderService.hide();

              this.gameOffers.forEach((game: any) => {
                if (game.GameName === 'Spinner') {
                  const spinCard = this.cardData.find(c => c.title === 'Spin');
                  if (spinCard) spinCard.hot = game.Text;
                } else if (game.GameName === 'ScratchCard') {
                  const scratchCard = this.cardData.find(c => c.title === 'Scratch');
                  if (scratchCard) scratchCard.hot = game.Text;
                }
              });

              this._loaderService.setArrayInLocalStorage(
                'bis_offer',
                this.gameOffers
              );
            } else {
              this._loaderService.hide();
            }
          },
          () => {
            this._loaderService.hide();
          }
        );
    }
  }
}